import styled from 'styled-components/macro';

export const AppSurface = styled.div``;
